import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs-compat';
import { catchError } from 'rxjs/operators';
import { BaseHttpClientService } from './base-http-client.service';

@Injectable()
export class InviteUsersService extends BaseHttpClientService {
  constructor(
    private http: HttpClient,
  ) {
    super()
  }

  public sendInviteUsers(body): Observable<any> {
    return (this.http.post(environment.apiUrl + `api/ext-skylark-user/bulk-worker-user-create`, body) as any)
      .pipe(catchError(this.handleError));
  }

  public getInviteDetails(activationToken: string): Observable<any> {
    return (this.http.get(environment.apiUrl + `api/ext-skylark-user/by-activation-key/${activationToken}`) as any)
      .pipe(catchError(this.handleError));
  }

  public getContractorInviteDetails(activationToken: string): Observable<any> {
    return (this.http.get(environment.apiUrl + `api/ext-skylark-user/maintenance/by-activation-key/${activationToken}`) as any)
      .pipe(catchError(this.handleError));
  }

  public submitPassword(body: any): Observable<any> {
    return (this.http.post(environment.apiUrl + `api/ext-skylark-user/activate-account`, body) as any)
      .pipe(catchError(this.handleError));

  }

  public resendInvite(login): Observable<any> {
    return (this.http.post(environment.apiUrl + `api/ext-skylark-user/reissue-invite/${encodeURIComponent(login)}`, {}) as any)
      .pipe(catchError(this.handleError));
  }
}
